import { render, staticRenderFns } from "./TariffMiniBurn.vue?vue&type=template&id=52e90c10&scoped=true&"
import script from "./TariffMiniBurn.vue?vue&type=script&lang=js&"
export * from "./TariffMiniBurn.vue?vue&type=script&lang=js&"
import style0 from "./TariffMiniBurn.vue?vue&type=style&index=0&id=52e90c10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e90c10",
  null
  
)

export default component.exports